/* eslint-disable react/display-name */
import React, { memo, useState } from  'react';
import styled from 'styled-components';

import { smallMediaQuery, mediumMediaQuery } from '../../common/utilities/sizeHelpers';
import { withScreenSize } from '../common/utilities/withScreenSize.jsx';
import { DisplayAdWidget } from '../ads/displayAdWidget.jsx';
import { AlertsListHeader } from '../alerts/alertsListHeader';
import { AlertsListContainerProps } from '../alerts/alertsInterfaces';
import { AirQualityItem } from './airQualityItem';
import { InfoIcon }  from '../common/icons/infoIcon';
import { translate } from '../../common/translation/translate';
import { AqiLegendPopup } from './aqiLegendPopup';
import { DisplayAdUnit } from '../../containers/ads/displayAdUnitContainer';

const showAlerts = true;

interface AirQualityListProps {
    activePageId: string;
    isMobile: boolean;
}

export const AirQualityList = memo(withScreenSize(({
    activePageId,
    isMobile
}: AirQualityListProps) => {
    const [ showAqiLegendPopup, setShowAqiLegendPopup ] = useState(false);

    const handleInfoIconClick = () => {
        setShowAqiLegendPopup(true);
    };

    return (
        <Container activePageId={activePageId} showAlerts={showAlerts} id='com.weatherbug.web:id/airQualityList'>
            <AlertsListHeader>
                {`${translate('airQualityHeaderTitle')}`}
                <InformationIconWrapper onClick={handleInfoIconClick}>
                    <InfoIcon/>
                </InformationIconWrapper>
            </AlertsListHeader>
            <AirQualityItem/>
            { showAqiLegendPopup 
                && <AqiLegendPopup 
                    open={showAqiLegendPopup} 
                    onClose={() => setShowAqiLegendPopup(false)}
                /> 
            }
            {!isMobile
                && <AdContainer>
                    <DisplayAdUnit
                        slotId='air-quality_info_x11'
                        height={250}
                        width={300}
                    />
                </AdContainer>
            }
        </Container>
    );
}));

const Container = styled.div<AlertsListContainerProps>`
    display: flex;
    flex-direction: column;
    background-color: #F9F9F9;
    height: 600px;
    width: 27%;

    @media ${mediumMediaQuery} {
        width: 47%;
    }

    @media ${smallMediaQuery} {
        width: 100%;
        height: 220px;
}
`;

const InformationIconWrapper = styled.a`
    cursor: pointer;
    margin: 4px 0 auto auto;
`;

const AdContainer = styled.div`
    margin: 20px auto;
    height: 250px;
`; 
